"use strict";
/**
 * @module Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var service_definition_1 = require("./../services/service-definition");
var topic_specification_info_serialiser_1 = require("./../topics/details/topic-specification-info-serialiser");
var message_receiver_control_registration_params_serialiser_1 = require("./../services/control/message-receiver-control-registration-params-serialiser");
var message_receiver_control_registration_request_serialiser_1 = require("./../services/control/message-receiver-control-registration-request-serialiser");
var topic_control_registration_params_serialiser_1 = require("./../services/control/topic-control-registration-params-serialiser");
var topic_control_registration_request_serialiser_1 = require("./../services/control/topic-control-registration-request-serialiser");
var unsubscription_notification_serialiser_1 = require("./../services/unsubscription-notification/unsubscription-notification-serialiser");
exports.TOPIC_CONTROL_REGISTRATION = {
    id: 20,
    request: topic_control_registration_request_serialiser_1.TopicControlRegistrationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.TOPIC_CONTROL_DEREGISTRATION = {
    id: 21,
    request: topic_control_registration_params_serialiser_1.TopicControlRegistrationParamsSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.UNSUBSCRIPTION_NOTIFICATION = {
    id: 42,
    request: unsubscription_notification_serialiser_1.UnsubscriptionNotificationSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.MESSAGE_RECEIVER_CONTROL_REGISTRATION = {
    id: 63,
    request: message_receiver_control_registration_request_serialiser_1.MessageReceiverControlRegistrationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.MESSAGE_RECEIVER_CONTROL_DEREGISTRATION = {
    id: 64,
    request: message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.NOTIFY_SUBSCRIPTION = {
    id: 87,
    request: topic_specification_info_serialiser_1.TopicSpecificationInfoSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.MESSAGING_RECEIVER_CONTROL_REGISTRATION = {
    id: 97,
    request: message_receiver_control_registration_request_serialiser_1.MessageReceiverControlRegistrationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.MESSAGING_RECEIVER_CONTROL_DEREGISTRATION = {
    id: 98,
    request: message_receiver_control_registration_params_serialiser_1.MessageReceiverControlRegistrationParamsSerialiser,
    response: service_definition_1.NullSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/services.js
// module id = 407
// module chunks = 0